export default "__VITE_ASSET__5d2aaa79__"